import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import './PaymentButton.scss';

import StripeButton from './StripeButton';
import BraintreePaypalButton from './BraintreePaypalButton';
import PaidForButton from './PaidForButton';
import PaypalCheckoutButton from './PaypalCheckoutButton';

import Loading from '../../Loading';

const PaymentButton = props => {
  const order = get(props, 'order', {});
  const totals = get(order, 'totals_v2', order.totals) || {};
  const orderTotal = get(totals, 'order.formatted') || '';
  let PaymentButton = null;

  if (props.method === 'stripe') {
    PaymentButton = (
      <StripeButton {...props} orderNumber={order.id} total={orderTotal} />
    );
  }

  if (props.method === 'paypal') {
    PaymentButton = (
      <BraintreePaypalButton {...props} />
    );
  }

  if (props.method === 'paypal_checkout') {
    PaymentButton = (
      <PaypalCheckoutButton  {...props} />
    );
  }

  if (props.method === 'free') {
    PaymentButton = (
      <PaidForButton {...props} />
    );
  }

  return (
    <div className="payment-buttons">
      {props.method === props.submittingMethod &&
        <Loading absolute xsmall dark fade />
      }
      {PaymentButton}
    </div>
  );
};

PaymentButton.propTypes = {
  method: PropTypes.string.isRequired,
  submittingMethod: PropTypes.string,
  setSubmittingMethod: PropTypes.func.isRequired,
  cta: PropTypes.string,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    totals: PropTypes.shape({
      order: PropTypes.shape({
        formatted: PropTypes.string,
      }),
    }),
    totals_v2: PropTypes.shape({
      order: PropTypes.shape({
        formatted: PropTypes.string,
      }),
    }),
  }),
  settings: PropTypes.object
};

export default PaymentButton;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaymentButton.js